module.exports = __webpack_public_path__ + "img/5_community-sp.286a3549.jpg";